import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type CalculationParamsSlice = {
  calculationFrom: Date | null;
  calculationTo: Date | null;
  changeCalculationFrom: (calculationFrom: Date) => void;
  changeCalculationTo: (calculationTo: Date) => void;
};

const initialData = {
  calculationFrom: null,
  calculationTo: null,
};

export const createCalculationParamsSlice: StateCreator<
  Store,
  [],
  [],
  CalculationParamsSlice
> = (set) => ({
  ...initialData,
  changeCalculationFrom: (calculationFrom) => set({ calculationFrom }),
  changeCalculationTo: (calculationTo) => set({ calculationTo }),
});
4;
